import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const alertVariants = cva(
  "testify-relative testify-w-full testify-rounded-lg testify-border testify-px-4 testify-py-3 testify-text-sm [&>svg+div]:testify-translate-y-[-3px] [&>svg]:testify-absolute [&>svg]:testify-left-4 [&>svg]:testify-top-4 [&>svg]:testify-text-foreground [&>svg~*]:testify-pl-7",
  {
    variants: {
      variant: {
        default: "testify-bg-background testify-text-foreground",
        destructive:
          "testify-border-destructive/50 testify-text-destructive dark:testify-border-destructive [&>svg]:testify-text-destructive",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
));
Alert.displayName = "Alert";

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn(
      "testify-mb-1 testify-font-medium testify-leading-none testify-tracking-tight",
      className,
    )}
    {...props}
  />
));
AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("testify-text-sm [&_p]:testify-leading-relaxed", className)}
    {...props}
  />
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };
